import { api } from './api.js';

export interface LibraryRecentRead {
  path: string;
  title: string;
  source: string;
  timestamp: string;
}

export interface LibraryEditionProgress {
  editionPath: string;
  editionTitle: string;
  readCount: number;
  totalArticles: number;
  lastReadAt: string;
}

export interface LibraryStats {
  recentReads: LibraryRecentRead[];
  totalHighlights: number;
  totalReads: number;
  inProgress: LibraryEditionProgress[];
  completed: LibraryEditionProgress[];
}

export function fetchLibraryStats() {
  return api.get<LibraryStats>('/library/stats');
}
